var md_tracker = [];
var loadBaseTracker = function () {
    if (!md_tracker.__SV) {
      window.MDIGITAL['md_tracker'] = md_tracker;
      var g, e;
      md_tracker._i = [];
      md_tracker.init = function (config, name) {
        function addEvent(instance, eventName) {
          var eventNameSplit = eventName.split(".");
          2 === eventNameSplit.length && (instance = instance[eventNameSplit[0]], eventName = eventNameSplit[1]);
          instance[eventName] = function () {
            instance.push([eventName].concat(Array.prototype.slice.call(arguments, 0)))
          }
        }

        var instance = md_tracker;
        "undefined" !== typeof name ? instance = md_tracker[name] = [] : name = "md_tracker";
        g = ["trackEvent", "trackEventLater", "flush", "set_config"];
        for (e = 0; e < g.length; e++) addEvent(instance, g[e]);
        if (config) {
          md_tracker._i.push([config, name])
        }
      };
      md_tracker.__SV = 1.2;
    }
}
var loadFullTracker = function () {
  /*
 * Licensed to CRATE Technology GmbH ("Crate") under one or more contributor
 * license agreements.  See the NOTICE file distributed with this work for
 * additional information regarding copyright ownership.  Crate licenses
 * this file to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.  You may
 * obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.  See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * However, if you have executed another commercial license agreement
 * with Crate these terms will supersede the license and you may use the
 * software solely pursuant to the terms of the relevant commercial agreement.
 */
    /*
     * Saved references to long variable names, so that closure compiler can
     * minimize file size.
     */
    var ArrayProto = Array.prototype
        , ObjProto = Object.prototype
        , slice = ArrayProto.slice
        , toString = ObjProto.toString
        , hasOwnProperty = ObjProto.hasOwnProperty
        , windowConsole = window.console
        , navigator = window.navigator
        , document = window.document
        , userAgent = navigator.userAgent
        , clientHintsPromise;

    if (navigator.userAgentData && navigator.userAgentData.platform) {
      clientHintsPromise = navigator.userAgentData.getHighEntropyValues(['architecture', 'bitness', 'model', 'platformVersion', 'uaFullVersion', 'fullVersionList', 'wow64'])
          .then(JSON.stringify);
    }

    /** @const */   var PRIMARY_INSTANCE_NAME = "md_tracker";

    /*
     * Dynamic... constants? Is that an oxymoron?
     */
    var SNIPPET_VERSION = (md_tracker && md_tracker['__SV']) || 0,

        // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
        // https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
        USE_XHR = (window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest()),

        // IE<10 does not support cross-origin XHR's but script tags
        // with defer won't block window.onload; ENQUEUE_REQUESTS
        // should only be true for Opera<12
        ENQUEUE_REQUESTS = !USE_XHR && (userAgent.indexOf('MSIE') == -1) && (userAgent.indexOf('Mozilla') == -1);

    /*
     * Closure-level globals
     */
    var _ = {}
        , DEFAULT_CONFIG = {
      "api_host": ""
      , "loaded": function () {
      }
      , "http_post": true
    }
        , DOM_LOADED = false;

    // UNDERSCORE
    // Embed part of the Underscore Library

    (function () {
      var nativeForEach = ArrayProto.forEach,
          nativeIsArray = Array.isArray,
          breaker = {};

      /**
       * @param {*=} obj
       * @param {function(...[*])=} iterator
       * @param {Object=} context
       */
      var each = _.each = function (obj, iterator, context) {
        if (obj == null) return;
        if (nativeForEach && obj.forEach === nativeForEach) {
          obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
          for (var i = 0, l = obj.length; i < l; i++) {
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) return;
          }
        } else {
          for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
              if (iterator.call(context, obj[key], key, obj) === breaker) return;
            }
          }
        }
      };

      _.extend = function (obj) {
        each(slice.call(arguments, 1), function (source) {
          for (var prop in source) {
            if (source[prop] !== void 0) obj[prop] = source[prop];
          }
        });
        return obj;
      };

      _.isArray = nativeIsArray || function (obj) {
        return toString.call(obj) === '[object Array]';
      };

      // from a comment on http://dbj.org/dbj/?p=286
      // fails on only one very rare and deliberate custom object:
      // var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
      _.isFunction = function (f) {
        try {
          return /^\s*\bfunction\b/.test(f);
        } catch (x) {
          return false;
        }
      };

      _.isArguments = function (obj) {
        return !!(obj && hasOwnProperty.call(obj, 'callee'));
      };

      _.toArray = function (iterable) {
        if (!iterable) return [];
        if (iterable.toArray) return iterable.toArray();
        if (_.isArray(iterable)) return slice.call(iterable);
        if (_.isArguments(iterable)) return slice.call(iterable);
        return _.values(iterable);
      };

      _.values = function (obj) {
        var results = [];
        if (obj == null) return results;
        each(obj, function (value) {
          results[results.length] = value;
        });
        return results;
      };

    })();

    // Underscore Addons
    _.isObject = function (obj) {
      return (obj === Object(obj) && !_.isArray(obj));
    };

    _.isUndefined = function (obj) {
      return obj === void 0;
    };

    _.isString = function (obj) {
      return toString.call(obj) == '[object String]';
    };

    _.strip_empty_properties = function (p) {
      var ret = {};
      _.each(p, function (v, k) {
        if (_.isString(v) && v.length > 0) {
          ret[k] = v;
        }
      });
      return ret;
    };

    _.utf8Encode = function (e) {
      e = e.replace(/\r\n/g, "\n");
      var t = "";
      for (var n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r < 128) {
          t += String.fromCharCode(r)
        } else if (r > 127 && r < 2048) {
          t += String.fromCharCode(r >> 6 | 192);
          t += String.fromCharCode(r & 63 | 128)
        } else {
          t += String.fromCharCode(r >> 12 | 224);
          t += String.fromCharCode(r >> 6 & 63 | 128);
          t += String.fromCharCode(r & 63 | 128)
        }
      }
      return t
    };

    _.base64Encode = function (data) {

      var Base64 = {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        , encode: function (e) {
          var t = "";
          var n, r, i, s, o, u, a;
          var f = 0;
          e = _.utf8Encode(e);
          while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) {
              u = a = 64
            } else if (isNaN(i)) {
              a = 64
            }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
          }
          return t
        }
      }

      return Base64.encode(data);
    };

    /**
     * @param {Object=} formdata
     * @param {string=} arg_separator
     */
    _.HTTPBuildQuery = function (formdata, arg_separator) {
      var key, use_val, use_key, tmp_arr = [];

      if (typeof (arg_separator) === "undefined") {
        arg_separator = '&';
      }

      _.each(formdata, function (val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
      });

      return tmp_arr.join(arg_separator);
    };

    _.getQueryParam = function (url, param) {
      // Expects a raw URL

      param = param.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + param + "=([^&#]*)",
          regex = new RegExp(regexS),
          results = regex.exec(url);
      if (results === null || (results && typeof (results[1]) !== 'string' && results[1].length)) {
        return '';
      } else {
        return decodeURIComponent(results[1]).replace(/\+/g, ' ');
      }
    };

    _.register_event = (function () {
      // written by Dean Edwards, 2005
      // with input from Tino Zijdel - crisp@xs4all.nl
      // with input from Carl Sverre - mail@carlsverre.com
      // with input from md_tracker
      // http://dean.edwards.name/weblog/2005/10/add-event/
      // https://gist.github.com/1930440

      /**
       * @param {Object} element
       * @param {string} type
       * @param {function(...[*])} handler
       * @param {boolean=} oldSchool
       */
      var register_event = function (element, type, handler, oldSchool) {
        if (!element) {
          windowConsole.log("No valid element provided to register_event");
          return;
        }

        if (element.addEventListener && !oldSchool) {
          element.addEventListener(type, handler, false);
        } else {
          var ontype = 'on' + type;
          var old_handler = element[ontype]; // can be undefined
          element[ontype] = makeHandler(element, handler, old_handler);
        }
      };

      function makeHandler(element, new_handler, old_handlers) {
        var handler = function (event) {
          event = event || fixEvent(window.event);

          // this basically happens in firefox whenever another script
          // overwrites the onload callback and doesn't pass the event
          // object to previously defined callbacks.  All the browsers
          // that don't define window.event implement addEventListener
          // so the dom_loaded handler will still be fired as usual.
          if (!event) {
            return undefined;
          }

          var ret = true;
          var old_result, new_result;

          if (_.isFunction(old_handlers)) {
            old_result = old_handlers(event);
          }
          new_result = new_handler.call(element, event);

          if ((false === old_result) || (false === new_result)) {
            ret = false;
          }

          return ret;
        };

        return handler;
      };

      function fixEvent(event) {
        if (event) {
          event.preventDefault = fixEvent.preventDefault;
          event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
      };
      fixEvent.preventDefault = function () {
        this.returnValue = false;
      };
      fixEvent.stopPropagation = function () {
        this.cancelBubble = true
      };

      return register_event;
    })();

    _.info = {
      properties: function () {
        return _.extend(_.strip_empty_properties({
          'sessionScreenSize': window.screen.width + 'x' + window.screen.height,
          'sessionDua': navigator.userAgent,
          'sessionPlatform': navigator.platform,
          'referringUrl': document.referrer,
          'pageTitle': document.title,
          'pageUrl': document.location.href
        }), {
          'type': 'website'
        });
      },
    };

    // Console override
    var console = {
      /** @type {function(...[*])} */
      critical: function () {
        if (!_.isUndefined(windowConsole) && windowConsole) {
          var args = ["md_tracker error:"].concat(_.toArray(arguments));
          try {
            windowConsole.error.apply(windowConsole, args);
          } catch (err) {
            _.each(args, function (arg) {
              windowConsole.error(arg);
            });
          }
        }
      }
    };

    /**
     * create_md_digitallib(config:object, name:string)
     *
     * This function is used by the init method of MD_DigitalLib objects
     * as well as the main initializer at the end of the JSLib (that
     * initializes md_tracker as well as any additional instances
     * declared before this file has loaded).
     */
    var create_md_digitallib = function (config, name) {
      var instance, target = (name === PRIMARY_INSTANCE_NAME) ? md_tracker : md_tracker[name];

      if (target && !_.isArray(target)) {
        windowConsole.log("You have already initialized " + name);
        return;
      }

      instance = new MD_DigitalLib();
      instance._init(config, name);

      // if target is not defined, we called init after the lib already
      // loaded, so there won't be an array of things to execute
      if (!_.isUndefined(target)) {

        instance._execute_array(target);
      }

      return instance;
    };

    /**
     * MD_Digital Library Object
     * @constructor
     */
    var MD_DigitalLib = function () {
    };

    // Initialization methods

    /**
     * This function initialize a new instance of the md_tracker tracking object.
     * All new instances are added to the main md_tracker object as sub properties (such as
     * md_tracker.your_library_name) and also returned by this function.  If you wanted
     * to define a second instance on the page you would do it like so:
     *
     *      md_tracker.init({ your: "config" }, "library_name")
     *
     * and use it like this:
     *
     *      md_tracker.library_name.track(...)
     *
     * @param {Object} [config]  A dictionary of config options to override
     * @param {String} [name]    The name for the new md_tracker instance that you want created
     */
    MD_DigitalLib.prototype.init = function (config, name) {
      if (typeof (name) === "undefined") {
        windowConsole.log("You must name your new library: init(config, name)");
        return;
      }
      if (name === PRIMARY_INSTANCE_NAME) {
        windowConsole.log("You must initialize the main md_tracker object right after you include the md_tracker js snippet");
        return;
      }

      var instance = create_md_digitallib(config, name);
      md_tracker[name] = instance;
      instance._loaded();

      return instance;
    };

    // md_tracker._init(userObject:object, name:string)
    //
    // This function sets up the current instance of the md_tracker
    // library.  The difference between this method and the init(...)
    // method is this one initializes the actual instance, whereas the
    // init(...) method sets up a new library and calls _init on it.
    //
    MD_DigitalLib.prototype._init = function (userObject, name) {
      this['__loaded'] = true;
      this['__SV'] = true;
      this['config'] = {};
      this['eventsArray'] = [];

      userObject = userObject || {};
      this.set_config(_.extend({}, DEFAULT_CONFIG, {
        "session_id": userObject.session_id
        , "http_post": userObject.http_post
        , "topic": userObject.topic
        , "name": name
        , "api_host": userObject.api_host
      }));

      this.__dom_loaded_queue = [];
      this.__request_queue = [];

      if (userObject.custom_event_handler) {
        this.__customEventHandler = userObject.custom_event_handler;
      }
    };

    MD_DigitalLib.prototype._loaded = function () {
      this.get_config('loaded')(this);
    };

    MD_DigitalLib.prototype._dom_loaded = function () {
      _.each(this.__dom_loaded_queue, function (item) {
        this._track_dom.apply(this, item);
      }, this);
      _.each(this.__request_queue, function (item) {
        this._send_request.apply(this, item);
      }, this);
      delete this.__dom_loaded_queue;
      delete this.__request_queue;
    };

    MD_DigitalLib.prototype._track_dom = function (DomClass, args) {
      if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([DomClass, args]);
        return false;
      }

      var dt = new DomClass().init(this);
      return dt.track.apply(dt, args);
    };

    MD_DigitalLib.prototype.trackEventLater = function (event_name, properties) {
      if (typeof (event_name) === "undefined") {
        windowConsole.log("No event name provided to md_tracker.trackEventLater");
        return;
      }

      properties = properties || {};

      var now = new Date();
      var data = _.extend(
          {}
          , _.info.properties()
          , {
            'eventName': event_name,
            'timestamp': now.toISOString(),
            'eventTimezoneOffset': -1.0 * (now.getTimezoneOffset() / 60)
          }
      );

      data = _.extend(data, properties);

      if (clientHintsPromise) {
        var self = this;
        clientHintsPromise.then(function (clientHintsValues) {
          data = _.extend(data, {clientHints: clientHintsValues});
        }).catch(function () {
        }).then(function () {
          self.eventsArray.push(data);
        });
      } else {
        this.eventsArray.push(data);
      }
    };

    MD_DigitalLib.prototype.flush = function () {
      var data = this.eventsArray;
      this._send_request(data);
      this.eventsArray = [];
    };

    MD_DigitalLib.prototype._onError = function (data, callback) {
      //windowConsole.log('onError');
    }

    MD_DigitalLib.prototype._send_request = function (data, callback) {
      if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return;
      }

      if (this.__customEventHandler && this.__customEventHandler.handleRequest) {
        var endpointType = null;
        if (USE_XHR) {
          endpointType = 'post';
        }
        this.__customEventHandler.handleRequest(this, data, endpointType);
        return;
      }

      var url = this.get_config('api_host');
      var topic = this.get_config('topic');

      var payload = JSON.stringify(data);

      if (USE_XHR) {
        var req = new XMLHttpRequest();
        req.open("POST", url, true);
        req.setRequestHeader("Content-type", "application/json");
        req.setRequestHeader("charset", "UTF-8");
        if (topic) {
          req.setRequestHeader("Mec-Integration-Id", topic);
        }

        req.onreadystatechange = function (e) {
          if (req.readyState === 4) { // XMLHttpRequest.DONE == 4, except in safari 4
            if (req.status === 200) {
              if (callback) {
                callback();
              }
            } else {
              var error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
              windowConsole.log(error);
            }
          }
        };
        req.send(payload);

      } else {
        var that = this;
        data = {'data': _.base64Encode(payload)};
        if (topic) {
          data['mecIntegrationId'] = _.base64Encode(topic);
        }
        url += '/da.gif?' + _.HTTPBuildQuery(data);
        var img = document.createElement("img");
        img.onerror = function () {
          that._onError(data, callback);
        }
        img.width = 1;
        img.height = 1;
        img.src = url;
      }
    };

    /**
     * _execute_array() deals with processing any md_tracker function
     * calls that were called before the MD_Digital library were loaded
     * (and are thus stored in an array so they can be called later)
     *
     * Note: we fire off all the md_tracker function calls && user defined
     * functions BEFORE we fire off md_tracker tracking calls.  This is so
     * identify/register/set_config calls can properly modify early
     * tracking calls.
     *
     * @param {Array} array
     */
    MD_DigitalLib.prototype._execute_array = function (array) {
      var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
      _.each(array, function (item) {
        if (item) {
          fn_name = item[0];
          if (typeof (item) === "function") {
            item.call(this);
          } else if (_.isArray(item) && fn_name === 'alias') {
            alias_calls.push(item);
          } else if (_.isArray(item) && (fn_name.indexOf('track') != -1 || fn_name.indexOf('flush') != -1) && typeof (this[fn_name]) === "function") {
            tracking_calls.push(item);
          } else {
            other_calls.push(item);
          }
        }
      }, this);

      var execute = function (calls, context) {
        _.each(calls, function (item) {
          this[item[0]].apply(this, item.slice(1));
        }, context);
      };

      execute(alias_calls, this);
      execute(other_calls, this);
      execute(tracking_calls, this);
    };

    /**
     * push() keeps the standard async-array-push
     * behavior around after the lib is loaded.
     * This is only useful for external integrations that
     * do not wish to rely on our convenience methods
     * (created in the snippet). Good example is Optimizely.
     *
     * ### Usage:
     *     md_tracker.push(['register', { a: 'b' }]);
     *
     * @param {Array} item A [function_name, args...] array to be executed
     */
    MD_DigitalLib.prototype.push = function (item) {
      this._execute_array([item]);
    };

    /**
     * Track an event.  This is the most important md_tracker function and
     * the one you will be using the most.
     *
     * ### Usage:
     *
     *     // track an event named "Registered"
     *     md_tracker.track("Registered", {"Gender": "Male", "Age": 21});
     *
     *
     * @param {String} event_name The name of the event. This can be anything the user does - "Button Click", "Sign Up", "Item Purchased", etc.
     * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
     */
    MD_DigitalLib.prototype.trackEvent = function (event_name, properties, callback) {
      if (typeof (event_name) === "undefined") {
        windowConsole.log("No event name provided to md_tracker.trackEvent");
        return;
      }

      // set defaults
      properties = properties || {};

      // note: extend writes to the first object, so lets make sure we
      // don't write to the cookie properties object and info
      // properties object by passing in a new object

      var now = new Date();

      // update properties with pageview info and super-properties
      var data = _.extend(
          {}
          , _.info.properties()
          , {
            'eventName': event_name,
            'timestamp': now.toISOString(),
            'eventTimezoneOffset': -1.0 * (now.getTimezoneOffset() / 60)
          }
      );

      data = _.extend(data, properties);

      if (clientHintsPromise) {
        clientHintsPromise.then(function (clientHintsValues) {
          data = _.extend(data, {clientHints: clientHintsValues});
        }).catch(function () {
        }).then(this._send_events.bind(this, data, callback));
      } else {
        this._send_events(data, callback);
      }
    };

    MD_DigitalLib.prototype._send_events = function (events, callback) {
      this._send_request(
          [events],
          callback
      );
    }

    /**
     * Update the configuration of a md_tracker library instance.
     *
     * @param {Object} config A dictionary of new configuration values to update
     */
    MD_DigitalLib.prototype.set_config = function (config) {
      if (_.isObject(config)) {
        _.extend(this['config'], config);
      }
    };

    /**
     * returns the current config object for the library.
     */
    MD_DigitalLib.prototype.get_config = function (prop_name) {
      return this['config'][prop_name];
    };

    /**
     * Returns the value of the super property named property_name. If no such
     * property is set, get_property will return the undefined value.
     *
     * @param {String} property_name The name of the super property you want to retrieve
     */
    // MD_DigitalLib.prototype.get_property = function(property_name) {
    //     return this['cookie']['props'][property_name];
    // };

    MD_DigitalLib.prototype.toString = function () {
      var name = this.get_config("name");
      if (name !== PRIMARY_INSTANCE_NAME) {
        name = PRIMARY_INSTANCE_NAME + "." + name;
      }
      return name;
    };

    // EXPORTS (for closure compiler)

    // Underscore Exports
    /*eslint-disable no-self-assign*/
    _['toArray'] = _.toArray;
    _['isObject'] = _.isObject;
    _['info'] = _.info;
    /*eslint-disable no-self-assign*/

    // MD_DigitalLib Exports
    /*eslint-disable no-self-assign*/
    MD_DigitalLib.prototype['init'] = MD_DigitalLib.prototype.init;
    MD_DigitalLib.prototype['track_event'] = MD_DigitalLib.prototype.trackEvent;
    MD_DigitalLib.prototype['track_event_later'] = MD_DigitalLib.prototype.trackEventLater;
    MD_DigitalLib.prototype['flush'] = MD_DigitalLib.prototype.flush;
    MD_DigitalLib.prototype['set_config'] = MD_DigitalLib.prototype.set_config;
    MD_DigitalLib.prototype['get_config'] = MD_DigitalLib.prototype.get_config;
    MD_DigitalLib.prototype['toString'] = MD_DigitalLib.prototype.toString;
    /*eslint-disable no-self-assign*/

    // Initialization
    if (_.isUndefined(md_tracker)) {
      // md_tracker wasn't initialized properly, report error and quit
      console.critical("'md_tracker' object not initialized. Ensure you are using the latest version of the md_tracker JS Library along with the snippet we provide.");
      return;
    }
    if (md_tracker['__loaded'] || md_tracker['config']) {
      // lib has already been loaded at least once; we don't want to override the global object this time so bomb early
      windowConsole.log("md_tracker library has already been downloaded at least once.");
      return;
    }
    if (SNIPPET_VERSION < 1.1) {
      // md_tracker wasn't initialized properly, report error and quit
      windowConsole.critical("Version mismatch; please ensure you're using the latest version of the md_tracker code snippet.");
      return;
    }

    // Load instances of the md_tracker Library
    var instances = {};
    _.each(md_tracker['_i'], function (item) {
      var name, instance;
      if (item && _.isArray(item)) {
        name = item[item.length - 1];
        instance = create_md_digitallib.apply(this, item);

        instances[name] = instance;
      }
    });

    var extend_cd = function () {
      // add all the sub md_tracker instances
      _.each(instances, function (instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) {
          md_tracker[name] = instance;
        }
      });

      // add private functions as _
      md_tracker['_'] = _;
    };

    // we override the snippets init function to handle the case where a
    // user initializes the md_tracker library after the script loads & runs
    md_tracker['init'] = function (config, name) {
      if (name) {
        // initialize a sub library
        if (!md_tracker[name]) {
          md_tracker[name] = instances[name] = create_md_digitallib(config, name);
          md_tracker[name]._loaded();
        }
      } else {
        var instance = md_tracker;

        if (instances[PRIMARY_INSTANCE_NAME]) {
          // main md_tracker lib already initialized
          instance = instances[PRIMARY_INSTANCE_NAME];
        } else {
          // intialize the main md_tracker lib
          instance = create_md_digitallib(config, PRIMARY_INSTANCE_NAME);
          if (instance)
            instance._loaded();
        }

        window.MDIGITAL[PRIMARY_INSTANCE_NAME] = md_tracker = instance;
        extend_cd();
      }
    };

    md_tracker['init']();

    // Fire loaded events after updating the window's md_tracker object
    _.each(instances, function (instance) {
      instance._loaded();
    });

    // Cross browser DOM Loaded support

    function dom_loaded_handler() {
      // function flag since we only want to execute this once
      if (dom_loaded_handler.done) {
        return;
      }
      dom_loaded_handler.done = true;

      DOM_LOADED = true;
      ENQUEUE_REQUESTS = false;

      _.each(instances, function (inst) {
        inst._dom_loaded();
      });
    }

    if (document.addEventListener) {

      if (document.readyState == "complete") {
        // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
      } else {
        document.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
      }
    } else if (document.attachEvent) {
      // IE
      document.attachEvent("onreadystatechange", dom_loaded_handler);

      // check to make sure we aren't in a frame
      var toplevel = false;
      try {
        toplevel = window.frameElement == null;
      } catch (e) {
      }

      if (document.documentElement.doScroll && toplevel) {
        do_scroll_check();
      }
    }

    function do_scroll_check() {
      try {
        document.documentElement.doScroll("left");
      } catch (e) {
        setTimeout(do_scroll_check, 1);
        return;
      }

      dom_loaded_handler();
    }

    // fallback handler, always will work
    _.register_event(window, 'load', dom_loaded_handler, true);
}
export default {
  loadBaseTracker: loadBaseTracker,
  loadFullTracker: loadFullTracker,
  md_tracker: md_tracker,
}